// extracted by mini-css-extract-plugin
export default {"revenueContent":"Tickets_revenueContent__aJgtU"};